import { Options } from 'vue-class-component';
import TimeSelectorComponent from '../../../TimeSelectorComponent/TimeSelectorComponent.vue';
import WeekDaysSelectorComponent from '../../../WeekDaysSelectorComponent/WeekDaysSelectorComponent.vue';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionDateTime',
  components: {
    TimeSelectorComponent,
    WeekDaysSelectorComponent,
  },
})
export default class TriggerAndConditionDateTime extends SceneTriggerAndConditionGeneral {
  get isConfirmEnabled() {
    let t = this.triggerOrActionToAdd as any;
    if(t.time !== undefined) return !!t.time;
    if(t.startTime !== undefined) return !!t.startTime && !!(this.triggerOrActionToAdd as any).endTime;
    return false;
  }
}
